<div class="step-two" [class.step-two--edit]="isEditStepper">
  <div class="step-two__layout">
    <div class="step-two__back">
      <ds-button-v2
        emphasis="terciary"
        size="xs"
        leadingIcon="ArrowBack"
        [label]="isEditStepper ? stepTwo.editBack : stepTwo.back"
        (clicked)="goBack()"
      ></ds-button-v2>
    </div>

    <div class="step-two__columns">
      <div class="step-two__primary">
        <div class="step-two__heading">
          <p class="step-two__flow">{{ stepTwo.flowName }}</p>
          <div class="step-two__heading-text">
            <h2 class="step-two__title">{{ isEditStepper ? stepTwo.editTitle : stepTwo.title }}</h2>
            <p class="step-two__subtitle">{{ stepTwo.subtitle }}</p>
          </div>
        </div>

        <ds-card shadow="l2">
          <section class="step-two__card">
            <div class="step-two__card-header">
              <div class="step-two__card-heading">
                <h3 class="step-two__card-title">{{ stepTwo.regimeTitle }}</h3>
                <p class="step-two__card-subtitle">{{ stepTwo.regimeSubtitle }}</p>
              </div>
              <div class="step-two__link">
                <ds-button-v2
                  emphasis="terciary"
                  size="xs"
                  [label]="stepTwo.regimeLink"
                  (clicked)="showRegimeModal()"
                ></ds-button-v2>
              </div>
            </div>

            <div class="step-two__options step-two__options--regime">
              <button
                *ngFor="let regime of regimes"
                type="button"
                class="step-two__option"
                [class.step-two__option--selected]="regime.id === selectedRegime"
                [attr.aria-pressed]="regime.id === selectedRegime"
                (click)="selectRegime(regime.id)"
              >
                <span class="step-two__radio" aria-hidden="true"></span>
                <span class="step-two__option-content">
                  <span class="step-two__option-title">{{ regime.name }}</span>
                  <span class="step-two__option-description">{{ regime.description }}</span>
                </span>
              </button>
            </div>
          </section>
        </ds-card>

        <ds-card *ngIf="showFunds" shadow="l2">
          <section class="step-two__card" [attr.aria-busy]="!areFundsReady">
            <div class="step-two__card-header step-two__card-header--fund">
              <div class="step-two__card-heading">
                <h3 class="step-two__card-title">{{ fundTexts.title }}</h3>
                <p *ngIf="areFundsReady" class="step-two__card-subtitle">{{ fundTexts.subtitle }}</p>
              </div>
              <div *ngIf="areFundsReady" class="step-two__link">
                <ds-button-v2
                  emphasis="terciary"
                  size="xs"
                  [label]="fundTexts.link"
                  (clicked)="showMultifundsModal()"
                ></ds-button-v2>
              </div>
            </div>

            <div *ngIf="!areFundsReady" class="step-two__options" aria-hidden="true">
              <div *ngFor="let item of fundSkeletons" class="step-two__option step-two__option--skeleton">
                <span class="step-two__radio"></span>
                <span class="step-two__skeleton-bar"></span>
              </div>
            </div>

            <div *ngIf="areFundsReady" class="step-two__options step-two__options--fund">
              <button
                *ngFor="let fund of funds"
                type="button"
                class="step-two__option"
                [class.step-two__option--selected]="fund.id === selectedFund"
                [disabled]="isFundLocked(fund.id)"
                [attr.aria-pressed]="fund.id === selectedFund"
                (click)="selectFund(fund.id)"
              >
                <span class="step-two__radio" aria-hidden="true"></span>
                <span class="step-two__option-content">
                  <span class="step-two__option-head">
                    <span class="step-two__option-title">{{ fund.name }}</span>
                    <ds-tag-pill
                      *ngIf="isMultiFunds"
                      size="s"
                      [variant]="tagVariants[fund.tone ?? '']"
                      [label]="fund.risk ?? ''"
                    ></ds-tag-pill>
                  </span>
                  <span
                    *ngIf="fund.id === selectedFund && fund.description"
                    class="step-two__option-description"
                  >
                    {{ fund.description }}
                  </span>
                  <span
                    *ngIf="fund.id === selectedFund && rentabilityByFund[fund.id]"
                    class="step-two__option-description"
                  >
                    {{ rentabilityByFund[fund.id] }}
                  </span>
                </span>
              </button>
            </div>
          </section>
        </ds-card>

        <div class="step-two__submit">
          <div class="step-two__submit-action">
            <ds-button-v2
              emphasis="primary"
              size="m"
              [fullWidth]="true"
              maxWidth="100%"
              [disabled]="!canContinue"
              [label]="isEditStepper ? stepTwo.editSubmit : stepTwo.submitButton"
              (clicked)="isEditStepper ? saveChanges() : goToNextStep()"
            ></ds-button-v2>
          </div>
        </div>
      </div>

      <app-stepper-lateral
        *ngIf="!isEditStepper"
        class="step-two__stepper"
        [currentStep]="currentStepIndex"
      ></app-stepper-lateral>
    </div>
  </div>
</div>
